module.exports = __webpack_public_path__ + "media/icons/naprawa@3x-fb2f9fe1.svg";